import gql from 'graphql-tag';

export const add = gql`mutation CreateClientRate($clientRate: ClientRateInput!) {
    createClientRate(clientRate: $clientRate) {
        id
        name
        creationDate
        client {
            id
        }
        isMarineOnly
        rate
        franchise
    }
}`;

export const edit = gql`mutation EditClientRate($id: ID!, $clientRate: ClientRateInput!) {
    editClientRate(id: $id, clientRate: $clientRate) {
        id
        name
        creationDate
        client {
            id
        }
        isMarineOnly
        rate
        franchise
    }
}`;


export const remove = gql`mutation RemoveClientRate($id: ID!) {
    removeClientRate(id: $id) {
        id
        name
        creationDate
        client {
            id
        }
        isMarineOnly
        rate
        franchise
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/clientRate.js